import MainSlider from './main-slider.js';

document.addEventListener('DOMContentLoaded', () => {
    const arItemsSliders = document.getElementsByClassName('js-product-slider-main-page');

    if (arItemsSliders.length !== 0) {
        MainSlider(arItemsSliders);
    }


    addToFavorites('.js-add-favorites');
    delToFavorites('.js-remove-favorites');

    function addToFavorites(sSelector) {
        $(document).on('click', sSelector, function (oEvent) {
            oEvent.preventDefault();

            let oBtn = $(this),
                iId = oBtn.data('id'),
                sName = oBtn.data('name'),
                sPrice = oBtn.data('price'),
                oCounter = $('.fav-circl.favorites');

            window.BX.ajax.runComponentAction('ega:favorites', 'addToFavorites',
                {
                    mode: 'class',
                    data: { id: iId },
                })
                .then(() => {
                    oCounter.text((i, val) => +val + 1);

                    $('.header-add-product').find('.header-add-product-title').html('Товар добавлен в избранное').end().slideDown();

                    setTimeout(() => { $('.header-add-product').find('.header-add-product-title').html('').end().slideUp(); }, 3000);

                    oBtn
                        .removeClass('js-add-favorites')
                        .addClass('js-remove-favorites')
                        .addClass('active')
                        .off('click');

                    delToFavorites(this);

                    window.BX.ajax.runComponentAction('ega:favorites', 'sendFavoritesImshop', { mode: 'class' });

                    window.dataLayer = (window.dataLayer || []);

                    window.dataLayer.push(
                        {
                            'event': 'autoEvent',
                            'eventAction': 'wishlist',
                            'eventCategory': 'add',
                            'eventLabel': sName,
                            'id': iId,
                            'price': sPrice
                        });
                })
                .catch((oResponse) => {
                    console.group('.js-select change');
                    console.log('oResponse');
                    console.log(oResponse);
                    console.groupEnd();
                });
        });
    }

    function delToFavorites(sSelector) {
        $(document).on('click', sSelector, function (oEvent) {
            oEvent.preventDefault();

            let oBtn = $(this),
                iId = oBtn.data('id'),
                sName = oBtn.data('name'),
                sPrice = oBtn.data('price'),
                oCounter = $('.fav-circl.favorites');

            window.BX.ajax.runComponentAction('ega:favorites', 'deleteFromFavorites',
                {
                    mode: 'class',
                    data: { id: iId },
                })
                .then(() => {
                    oCounter.text((i, val) => +val - 1);

                    $('.header-add-product').find('.header-add-product-title').html('Товар удален из избранного').end().slideDown();

                    setTimeout(() => { $('.header-add-product').find('.header-add-product-title').html('').end().slideUp(); }, 3000);

                    oBtn
                        .removeClass('js-remove-favorites')
                        .addClass('js-add-favorites')
                        .off('click')
                        .removeClass('active');

                    addToFavorites(this);

                    window.BX.ajax.runComponentAction('ega:favorites', 'sendFavoritesImshop', { mode: 'class' });

                    window.dataLayer = (window.dataLayer || []);

                    window.dataLayer.push(
                        {
                            'event': 'autoEvent',
                            'eventAction': 'wishlist',
                            'eventCategory': 'remove',
                            'eventLabel': sName,
                            'id': iId,
                            'price': sPrice
                        });
                })
                .catch((oResponse) => {
                    console.group('.js-select change');
                    console.log('oResponse');
                    console.log(oResponse);
                    console.groupEnd();
                });
        });
    }
});